var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-nowrap align-center"},[_c('div',{ref:"captionGraph",staticClass:"caption-graph",style:(_vm.getCaptionGraphStyle())}),_c('p',{staticClass:"mb-0 ml-2"},[_vm._v(_vm._s(_vm.captionText))])])}
var staticRenderFns = []

export { render, staticRenderFns }